export default "__VITE_ASSET__BIptzCcT__"